import { render, staticRenderFns } from "./ContentFeed.vue?vue&type=template&id=4ce6cc69&scoped=true"
import script from "./ContentFeed.vue?vue&type=script&lang=js"
export * from "./ContentFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce6cc69",
  null
  
)

export default component.exports